import { memo } from 'react'

import { Translation } from 'cng-common/features/translations'

import styles from './ContactRelinkingHeader.module.scss'

type Props = {
  title: string
  description?: string
  titleParams?: { key: string; value: string }[]
  descriptionParams?: { key: string; value: string }[]
}

export const ContactRelinkingHeader = memo<Props>(
  ({ title, description = '', titleParams, descriptionParams }) => {
    return (
      <div className={styles.header}>
        <h5>
          <Translation text={title} span replaceParams={titleParams} htmlAvailable />
        </h5>
        <p>
          <Translation text={description} replaceParams={descriptionParams} span htmlAvailable />
        </p>
      </div>
    )
  }
)

ContactRelinkingHeader.displayName = 'ContactRelinkingHeader'
